module.exports = __webpack_public_path__ + "media/buy_report_icons/damages-a759be85.svg";